export default __webpack_public_path__ + "static/media/marysia-logo-large-black.7b5cf445.png";